import React, { useState } from 'react';
import classNames from 'classnames';
import css from './Tooltip.module.css';

const Tooltip = ({ children, content, position = 'top', className, ...rest }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className={classNames(css.tooltipWrapper, className)}
      {...rest}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children}

      {isVisible && <div className={classNames(css.tooltip, css[position])}>{content}</div>}
    </div>
  );
};

export default Tooltip;
